import { type IntlShape } from "react-intl";
import { z } from "zod";

export const getTrackOffsetRequestSchema = (intl: IntlShape) =>
	z.object({
		measuredWidth: z
			.number({
				message: intl.formatMessage({
					id: "Measured flap width must be a number",
					defaultMessage: "Measured flap width must be a number",
				}),
			})
			.min(
				0,
				intl.formatMessage({
					id: "Measured flap width must be greater than or equal to 0",
					defaultMessage: "Measured flap width must be greater than or equal to 0",
				}),
			)
			.max(
				1000,
				intl.formatMessage({
					id: "Measured flap width must be smaller than or equal to 1000",
					defaultMessage: "Measured flap width must be smaller than or equal to 1000",
				}),
			),
	});

export const trackOffsetValidationResultSchema = z.object({
	isValid: z.boolean(),
	newTrackOffset: z.number(),
	minimumPosition: z.number(),
});

export type TrackOffsetRequest = z.infer<ReturnType<typeof getTrackOffsetRequestSchema>>;
export type TrackOffsetValidationResult = z.infer<typeof trackOffsetValidationResultSchema>;
